
import { defineComponent, onMounted } from 'vue';
import { AppCard, AppTable, AppButton } from '@/components';
import useAppRoleList from '@/modules/role/app/model/list';
import { ROUTE_NAME_ROLE } from '@/modules/role/router';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_ROLE.APP.INDEX,
    components: { AppTable, AppButton, AppCard },
    setup() {
        const { list, total, query, fetchList, actions } = useAppRoleList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Text, label: 'Account Id', key: 'accountId' },
                { type: TableColumnType.Text, label: 'name', key: 'name' },
                { type: TableColumnType.Text, label: 'email', key: 'email' },
                { type: TableColumnType.Text, label: 'role', key: 'role' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        onClick: () => actions.removeAppRole(row.accountId, row.role)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { table, list, total, query, fetchList, ROUTE_NAME_ROLE };
    }
});
